import {
  Box,
  Button,
  CardHeader,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  InputBase,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { login } from "../services/auth";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { t } from "i18next";
import { toast } from "react-toastify";
import { getErrorMessage } from "../services/client";
import { getHissoAddress, hissoLogin, signup, verifyAndLinkHissoAccount } from "../services/auth";
import { selectedMenuState } from "../recoil";
import { useRecoilState } from "recoil";

export default function LoginForm() {
  const [userId, setUserId] = useState<string>("");
  const [authId, setAuthId] = useState("");
  const [password, setPassword] = useState<string>("");
  const [authPassword, setAuthPassword] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["rememberUserId"]);
  const [isRemember, setIsRemember] = useState(false);
  const navigate = useNavigate();
  const clientName = process.env.REACT_APP_CLIENT_NAME || "HAIF";
  const [hissoUser, setHissoUser] = useState(null);
  const [selectedMenu, setSelectedMenu] = useRecoilState(selectedMenuState);
  const [emailMatchedUser, setEmailMatchedUser] = useState<any>(null);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [showAuthLinkModal, setShowAuthLinkModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const hissoView = Number(process.env.REACT_APP_HISSO_MODE);
  const [mode, setMode] = useState<"login" | "signup">("login");
  const [signupId, setSignupId] = useState(""); // 회원가입 아이디
  const [signupPassword, setSignupPassword] = useState(""); // 회원가입 비밀번호
  const [signupName, setSignupName] = useState("");
  const [signupStep, setSignupStep] = useState<1 | 2>(1);
  const [signupLoading, setSignupLoading] = useState(false);

  useEffect(() => {
    // 쿠키에 저장된 아이디가 있으면 자동으로 채워줌
    if (cookies.rememberUserId) {
      setUserId(cookies.rememberUserId);
      setIsRemember(true);
    }
  }, [cookies]);

  const func_saveUser = (response: any, refresh_token: string) => {
    const user = response.user;
    const columnSize = JSON.parse(user.config).web.column_size;
    const token = response.token;
    const userData = {
      id: user.id,
      userId: user.user_id,
      name: user.name,
      isAdmin: user.is_admin,
      authority: user.authority,
    };

    sessionStorage.setItem("refreshToken", refresh_token);
    localStorage.setItem("userData", JSON.stringify(userData));
    localStorage.setItem("token", JSON.stringify(token));
    localStorage.setItem("columnResize", JSON.stringify(columnSize));
    toast.success("로그인 성공");
    navigate("/main/dashboard");
    setSelectedMenu("대시보드");
  };

  useEffect(() => {
    async function handleMessage(event: any) {
      if (event.data.message === "LOGIN_SUCCESS" || event.data.message === "SIGNIN_SUCCESS") {
        setHissoUser(event.data.user);
        // localStorage.setItem("user", JSON.stringify(event.data.user));
        // localStorage.setItem("publicToken", event.data.public_token);
        try {
          const response = await hissoLogin(event.data.public_token, event.data.type);
          console.log("response", response);
          const status = response.status;
          const user = response.user;

          switch (status) {
            // 1. Hisso 연동 완료된 경우
            case "HISSO_USER_MATCHED":
              console.log("Hisso 연동 완료된 사용자", response);
              func_saveUser(response, event.data.refresh_token);
              break;

            // 2. Hisso 가입 이메일로 기존 계정 발견한 경우
            case "HISSO_EMAIL_MATCHED":
              console.log("Hisso 가입 이메일로 기존 계정 발견", response);
              setEmailMatchedUser(user);
              setShowLinkModal(true);
              break;

            // 3. Hisso 와 관련된 계정이 없어 신규 생성된 경우
            case "SIGNUP_NEEDED":
              console.log("Hisso 와 관련된 계정이 없어 회원가입 필요", response);
              setHissoUser(user);
              setShowSignupModal(true);
              break;
            default:
              break;
          }
        } catch (error: any) {
          console.error("hissoLogin error => ", error);
          if (error.response.data.message) {
            toast.error(error.response.data.message || "Hisso 로그인 실패");
          }
        }
        // navigate("/mainHome");
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const user = await login({ user_id: userId, pw: password });
      // console.log("user", user);
      if (isRemember) {
        setCookie("rememberUserId", userId, {
          path: "/",
          maxAge: 60 * 60 * 24 * 7,
        }); // 7일 유지
      } else {
        removeCookie("rememberUserId");
      }
      navigate("/main/dashboard");
      localStorage.removeItem("sw-cert-dismissed");
      // localStorage.setItem("demoMode", "false");
    } catch (error: any) {
      console.error(error);
      toast.error(
        error?.response?.status === 401 ? "잘못된 아이디 혹은 비밀번호입니다." : getErrorMessage(error),
      );
    }
  };

  const handleHissoLogin = async (id: string) => {
    let hissoAddress = null;
    try {
      const response = await getHissoAddress();
      hissoAddress = response.hisso_address;
    } catch (error) {
      console.error("getHissoAddress error => ", error);
    }

    const popupWidth = 400;
    const popupHeight = 700;

    // 현재 화면
    const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // 팝업을 중앙에 위치시키기 위한 계산
    const left = screenLeft + (screenWidth - popupWidth) / 2;
    const top = screenTop + (screenHeight - popupHeight) / 2;
    if (hissoAddress) {
      window.open(
        `http://${hissoAddress}/login?client=${clientName}${id ? `&user_id=${id}` : ""}`,
        "Hisso Login",
        `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
      );
    } else {
      toast.error("Hisso 서버를 찾을 수 없습니다.");
      return;
    }
  };

  // Hisso 계정 연동 처리
  const handleLink = async () => {
    setShowAuthLinkModal(true);
  };

  // 다른 계정으로 로그인 페이지 이동
  const goToLoginPage = () => {
    console.log("다른계정 연동");
    setShowLinkModal(false);
    setEmailMatchedUser(null);
    setShowAuthLinkModal(true);
    setMode("login");
    setSignupStep(1);
    // handleHissoLogin();
  };

  const onVerifyAndLink = async (login_id: string, pw: string) => {
    try {
      const response = await verifyAndLinkHissoAccount(login_id, pw, hissoUser);
      if (response.status === "LINK_SUCCESS") {
        toast.success(response.message);
        setShowAuthLinkModal(false);
        setShowLinkModal(false);
        console.log("response", response);
        handleHissoLogin(response.user_id);
        return true;
      } else {
        toast.error(response.message);
        return false;
      }
    } catch (error: any) {
      console.error("계정 연동 오류:", error);
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("계정 연동 중 오류가 발생했습니다.");
      }
      return false;
    }
  };

  // 새 계정 생성 페이지 이동
  const goToSignup = () => {
    setShowLinkModal(false);
  };

  const handleAuthSubmit = async () => {
    if (!authId || !authPassword) {
      console.log(authId, authPassword);
      toast.error("아이디와 비밀번호를 모두 입력해주세요.");
      return;
    }
    if (confirm() === false) return;

    const success = await onVerifyAndLink(authId, authPassword);

    if (!success) {
      toast.error("인증에 실패했습니다. 다시 시도해주세요.");
    }
  };

  const handleSignupSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (signupLoading) return;
    setSignupLoading(true);
    try {
      const { message } = await signup({
        user_id: signupId.trim(),
        pw: signupPassword,
        name: signupName.trim(),
      });
      toast.success(message);
      // 승인 전에는 로그인할 수 없으므로 입력만 비우고 로그인 화면으로 돌아간다
      setSignupId("");
      setSignupPassword("");
      setSignupName("");
      setSignupStep(1);
      setMode("login");
    } catch (error: any) {
      toast.error(getErrorMessage(error));
    } finally {
      setSignupLoading(false);
    }
  };

  const confirm = () => {
    const result = window.confirm("정말로 이 계정과 Hisso 계정을 연동하시겠습니까?");
    return result;
  };

  const handleDownloadManual = () => {
    const link = document.createElement("a");
    link.href = "/manual/manual.pdf";
    link.download = "HAIF-Pro-Manual.pdf";
    link.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "var(--dk-surface-3, #e8eaed)",
      }}
    >
      <Box
        sx={{
          width: "380px",
          backgroundColor: "var(--dk-surface-2, #f5f5f7)",
          borderRadius: "18px",
          overflow: "hidden",
          border: "0.5px solid var(--dk-border, rgba(0,0,0,0.12))",
          boxShadow: `
          0 2px 0 rgba(255,255,255,0.8) inset,
          0 20px 60px rgba(0,0,0,0.18),
          0 1px 3px rgba(0,0,0,0.1)
        `,
        }}
      >
        {/* 타이틀 바 */}
        <Box
          sx={{
            height: "40px",
            backgroundColor: "var(--dk-surface-glass, rgba(255,255,255,0.55))",
            backdropFilter: "blur(12px)",
            borderBottom: "0.5px solid var(--dk-border, rgba(0,0,0,0.1))",
            display: "flex",
            alignItems: "center",
            px: "14px",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              flex: 1,
              textAlign: "center",
              fontSize: "13px",
              fontWeight: 500,
              color: "var(--dk-text-2, #3a3a3c)",
              letterSpacing: "-0.01em",
              mr: "52px",
              fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif`,
            }}
          >
            {mode === "login" ? "HAIF Pro — Sign in" : "HAIF Pro — Sign up"}
          </Typography>
        </Box>

        <Box
          sx={{
            px: "28px",
            pt: "32px",
            pb: "28px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* 로고 + 브랜드 */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", mb: "28px" }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                backgroundColor: "#2563eb",
                borderRadius: "11px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(37,99,235,0.35)",
                flexShrink: 0,
              }}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <circle cx="12" cy="8" r="3" />
                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                <path d="M18 6l3 3-3 3" />
              </svg>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "var(--dk-text, #1d1d1f)",
                  letterSpacing: "-0.02em",
                  fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                }}
              >
                HAIF Pro
              </Typography>
            </Box>
          </Box>

          {/* 서브 타이틀 */}
          <Typography
            sx={{
              fontSize: "13px",
              color: "var(--dk-text-2, #6e6e73)",
              letterSpacing: "-0.01em",
              mb: "22px",
              fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
            }}
          >
            {mode === "login" ? "Sign in to your workspace" : "Create your account"}
          </Typography>

          {/* ───────────────── 로그인 화면 ───────────────── */}
          {mode === "login" && (
            <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  backgroundColor: "var(--dk-surface, white)",
                  borderRadius: "12px",
                  border: "0.5px solid var(--dk-border, rgba(0,0,0,0.13))",
                  overflow: "hidden",
                  mb: "14px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", px: "14px", height: "48px" }}>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "var(--dk-text, #1d1d1f)",
                      width: "80px",
                      flexShrink: 0,
                      letterSpacing: "-0.01em",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                    }}
                  >
                    Username
                  </Typography>
                  <InputBase
                    fullWidth
                    id="login-username"
                    name="username"
                    autoFocus
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    placeholder="Enter username"
                    sx={{
                      fontSize: "14px",
                      color: "var(--dk-text, #1d1d1f)",
                      letterSpacing: "-0.01em",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      "& input::placeholder": { color: "var(--dk-text-3, #aeaeb2)" },
                    }}
                  />
                </Box>

                <Box sx={{ height: "0.5px", backgroundColor: "rgba(0,0,0,0.09)", mx: "14px" }} />

                <Box sx={{ display: "flex", alignItems: "center", px: "14px", height: "48px" }}>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "var(--dk-text, #1d1d1f)",
                      width: "80px",
                      flexShrink: 0,
                      letterSpacing: "-0.01em",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                    }}
                  >
                    Password
                  </Typography>
                  <InputBase
                    fullWidth
                    name="password"
                    type="password"
                    id="login-password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    sx={{
                      fontSize: "14px",
                      color: "var(--dk-text, #1d1d1f)",
                      letterSpacing: "-0.01em",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      "& input::placeholder": { color: "var(--dk-text-3, #aeaeb2)" },
                    }}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "20px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isRemember}
                      onChange={(e) => setIsRemember(e.target.checked)}
                      size="small"
                      sx={{
                        p: "2px",
                        mr: "4px",
                        color: "var(--dk-text-3, #c7c7cc)",
                        "&.Mui-checked": { color: "#2563eb" },
                        "& .MuiSvgIcon-root": { borderRadius: "5px", fontSize: "18px" },
                      }}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "var(--dk-text-2, #3a3a3c)",
                        letterSpacing: "-0.01em",
                        fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      }}
                    >
                      {t("RememberMe")}
                    </Typography>
                  }
                  sx={{ m: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#2563eb",
                    cursor: "pointer",
                    letterSpacing: "-0.01em",
                    fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Forgot password?
                </Typography>
              </Box>

              <Button
                id="login-button"
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  height: "44px",
                  backgroundColor: "#2563eb",
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: 600,
                  letterSpacing: "-0.01em",
                  textTransform: "none",
                  fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                  boxShadow: "0 1px 0 rgba(255,255,255,0.2) inset, 0 2px 8px rgba(37,99,235,0.3)",
                  "&:hover": { backgroundColor: "#1d4ed8", boxShadow: "0 2px 12px rgba(37,99,235,0.4)" },
                  "&:active": { transform: "scale(0.98)" },
                }}
              >
                {t("Login")}
              </Button>

              {/* Sign Up 버튼 -> 회원가입 화면으로 전환 */}
              <Button
                id="signup-button"
                fullWidth
                variant="contained"
                onClick={() => setMode("signup")}
                sx={{
                  mt: 1.5,
                  height: "44px",
                  backgroundColor: "var(--dk-surface-2, #f3f4f6)",
                  color: "var(--dk-text-2, #374151)",
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: 600,
                  letterSpacing: "-0.01em",
                  textTransform: "none",
                  fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                  boxShadow: "0 1px 0 rgba(255,255,255,0.8) inset",
                  "&:hover": { backgroundColor: "var(--dk-surface-3, #e5e7eb)", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
                  "&:active": { transform: "scale(0.98)" },
                }}
              >
                {t("SignUp")}
              </Button>

              {hissoView && (
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handleHissoLogin(userId)}
                  startIcon={<Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#2563eb" }} />}
                  sx={{
                    mt: "10px",
                    height: "40px",
                    backgroundColor: "var(--dk-surface, white)",
                    borderRadius: "12px",
                    border: "0.5px solid var(--dk-border, rgba(0,0,0,0.16))",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "var(--dk-text-2, #3a3a3c)",
                    textTransform: "none",
                    letterSpacing: "-0.01em",
                    fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    "&:hover": { backgroundColor: "var(--dk-surface-2, #f5f5f7)", borderColor: "var(--dk-border, rgba(0,0,0,0.2))" },
                  }}
                >
                  Continue with Hisso
                </Button>
              )}
              <Button
                fullWidth
                variant="outlined"
                onClick={handleDownloadManual}
                startIcon={<Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#2563eb" }} />}
                sx={{
                  mt: "10px",
                  height: "40px",
                  backgroundColor: "var(--dk-surface, white)",
                  borderRadius: "12px",
                  border: "0.5px solid var(--dk-border, rgba(0,0,0,0.16))",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--dk-text-2, #3a3a3c)",
                  textTransform: "none",
                  letterSpacing: "-0.01em",
                  fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                  boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                  "&:hover": { backgroundColor: "var(--dk-surface-2, #f5f5f7)", borderColor: "var(--dk-border, rgba(0,0,0,0.2))" },
                }}
              >
                Download Manual
              </Button>
            </Box>
          )}

          {/* 회원가입 화면 */}
          {mode === "signup" && (
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                if (signupStep === 1) {
                  // 1단계: 이름 입력 후 다음 단계로
                  if (!signupName.trim()) return;
                  setSignupStep(2);
                } else {
                  // 2단계: 최종 회원가입 제출
                  handleSignupSubmit(e);
                }
              }}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              {/* 1단계: 이름*/}
              {signupStep === 1 && (
                <>
                  <Box
                    sx={{
                      backgroundColor: "var(--dk-surface, white)",
                      borderRadius: "12px",
                      border: "0.5px solid var(--dk-border, rgba(0,0,0,0.13))",
                      overflow: "hidden",
                      mb: "20px",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", px: "14px", height: "48px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "var(--dk-text, #1d1d1f)",
                          width: "80px",
                          flexShrink: 0,
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                        }}
                      >
                        이름
                      </Typography>
                      <InputBase
                        fullWidth
                        id="signup-name"
                        name="signup-name"
                        autoFocus
                        value={signupName}
                        onChange={(e) => setSignupName(e.target.value)}
                        placeholder="사용자 명을 입력하세요"
                        sx={{
                          fontSize: "14px",
                          color: "var(--dk-text, #1d1d1f)",
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                          "& input::placeholder": { color: "var(--dk-text-3, #aeaeb2)" },
                        }}
                      />
                    </Box>
                  </Box>

                  {/* 다음 버튼 */}
                  <Button
                    id="signup-next-button"
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={!signupName.trim()}
                    endIcon={
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 6l6 6-6 6" />
                      </svg>
                    }
                    sx={{
                      height: "44px",
                      backgroundColor: "#2563eb",
                      borderRadius: "12px",
                      fontSize: "15px",
                      fontWeight: 600,
                      letterSpacing: "-0.01em",
                      textTransform: "none",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      boxShadow: "0 1px 0 rgba(255,255,255,0.2) inset, 0 2px 8px rgba(37,99,235,0.3)",
                      "&:hover": { backgroundColor: "#1d4ed8", boxShadow: "0 2px 12px rgba(37,99,235,0.4)" },
                      "&:active": { transform: "scale(0.98)" },
                      "&.Mui-disabled": { backgroundColor: "#c7d2fe", color: "white", boxShadow: "none" },
                    }}
                  >
                    다음
                  </Button>

                  <Button
                    fullWidth
                    variant="text"
                    onClick={() => {
                      setMode("login");
                      setSignupStep(1);
                    }}
                    sx={{
                      mt: 1.5,
                      height: "40px",
                      color: "#2563eb",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: 500,
                      letterSpacing: "-0.01em",
                      textTransform: "none",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      "&:hover": { backgroundColor: "rgba(37,99,235,0.06)" },
                    }}
                  >
                    ← 로그인으로 돌아가기
                  </Button>
                </>
              )}

              {/* 2단계: 아이디 / 비밀번호*/}
              {signupStep === 2 && (
                <>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "var(--dk-text-2, #3a3a3c)",
                      mb: "14px",
                      letterSpacing: "-0.01em",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                    }}
                  >
                    <b>{signupName}</b>님, 사용하실 계정 정보를 입력해주세요.
                  </Typography>

                  <Box
                    sx={{
                      backgroundColor: "var(--dk-surface, white)",
                      borderRadius: "12px",
                      border: "0.5px solid var(--dk-border, rgba(0,0,0,0.13))",
                      overflow: "hidden",
                      mb: "20px",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", px: "14px", height: "48px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "var(--dk-text, #1d1d1f)",
                          width: "80px",
                          flexShrink: 0,
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                        }}
                      >
                        아이디
                      </Typography>
                      <InputBase
                        fullWidth
                        id="signup-id"
                        name="signup-id"
                        autoFocus
                        value={signupId}
                        onChange={(e) => setSignupId(e.target.value)}
                        placeholder="아이디를 입력하세요"
                        sx={{
                          fontSize: "14px",
                          color: "var(--dk-text, #1d1d1f)",
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                          "& input::placeholder": { color: "var(--dk-text-3, #aeaeb2)" },
                        }}
                      />
                    </Box>

                    <Box sx={{ height: "0.5px", backgroundColor: "rgba(0,0,0,0.09)", mx: "14px" }} />
                    <Box sx={{ display: "flex", alignItems: "center", px: "14px", height: "48px" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "var(--dk-text, #1d1d1f)",
                          width: "80px",
                          flexShrink: 0,
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                        }}
                      >
                        비밀번호
                      </Typography>
                      <InputBase
                        fullWidth
                        id="signup-password"
                        name="signup-password"
                        type="password"
                        autoComplete="new-password"
                        value={signupPassword}
                        onChange={(e) => setSignupPassword(e.target.value)}
                        placeholder="••••••••"
                        sx={{
                          fontSize: "14px",
                          color: "var(--dk-text, #1d1d1f)",
                          letterSpacing: "-0.01em",
                          fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                          "& input::placeholder": { color: "var(--dk-text-3, #aeaeb2)" },
                        }}
                      />
                    </Box>
                  </Box>

                  <Button
                    id="signup-submit-button"
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={signupLoading || !signupId.trim() || !signupPassword}
                    sx={{
                      height: "44px",
                      backgroundColor: "#2563eb",
                      borderRadius: "12px",
                      fontSize: "15px",
                      fontWeight: 600,
                      letterSpacing: "-0.01em",
                      textTransform: "none",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      boxShadow: "0 1px 0 rgba(255,255,255,0.2) inset, 0 2px 8px rgba(37,99,235,0.3)",
                      "&:hover": { backgroundColor: "#1d4ed8", boxShadow: "0 2px 12px rgba(37,99,235,0.4)" },
                      "&:active": { transform: "scale(0.98)" },
                      "&.Mui-disabled": { backgroundColor: "#c7d2fe", color: "white", boxShadow: "none" },
                    }}
                  >
                    회원가입
                  </Button>

                  <Button
                    fullWidth
                    variant="text"
                    onClick={() => setSignupStep(1)}
                    sx={{
                      mt: 1.5,
                      height: "40px",
                      color: "#2563eb",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: 500,
                      letterSpacing: "-0.01em",
                      textTransform: "none",
                      fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif`,
                      "&:hover": { backgroundColor: "rgba(37,99,235,0.06)" },
                    }}
                  >
                    ← 이전
                  </Button>
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* ───── 기존 Hisso 연동 모달들은 그대로 유지 ───── */}
      {showLinkModal && emailMatchedUser && (
        <Dialog
          open={showLinkModal}
          onClose={() => setShowLinkModal(false)}
          PaperProps={{
            sx: {
              borderRadius: "14px",
              border: "0.5px solid var(--dk-border, rgba(0,0,0,0.12))",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            },
          }}
        >
          <DialogTitle sx={{ fontSize: "15px", fontWeight: 600, color: "var(--dk-text, #1d1d1f)" }}>
            Hisso 가입 시 사용한 email로 기존 계정을 찾았습니다
          </DialogTitle>
          <DialogContent>
            <Paper elevation={0} sx={{ p: 2, my: 1, backgroundColor: "var(--dk-surface-2, #f5f5f7)", borderRadius: "10px" }}>
              <p>이름: {emailMatchedUser.name || ""}</p>
              <p>이메일: {emailMatchedUser.email || ""}</p>
            </Paper>
            <p>이 계정과 Hisso 계정을 연동하시겠습니까?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLink}>이 계정과 연동하기</Button>
            <Button onClick={goToLoginPage}>다른 계정 연동하기</Button>
          </DialogActions>
        </Dialog>
      )}

      {showAuthLinkModal && (
        <Dialog
          open={showAuthLinkModal}
          onClose={() => setShowAuthLinkModal(false)}
          PaperProps={{
            sx: {
              borderRadius: "14px",
              border: "0.5px solid var(--dk-border, rgba(0,0,0,0.12))",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            },
          }}
        >
          <DialogTitle sx={{ fontSize: "15px", fontWeight: 600, color: "var(--dk-text, #1d1d1f)" }}>
            Hisso 계정과 기존 서비스 계정 연동을 위한 인증이 필요합니다.
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 1 }}>
              연동을 진행하기 위해 연동할 기존 서비스 계정의 아이디와 비밀번호를 입력해주세요.
            </Typography>
            {emailMatchedUser && (
              <>
                <Typography sx={{ mb: 1 }}>아래 계정과 연동을 진행하기 위해 로그인해주세요.</Typography>
                <Paper elevation={0} sx={{ p: 2, my: 1, backgroundColor: "var(--dk-surface-2, #f5f5f7)", borderRadius: "10px" }}>
                  <p>이름: {emailMatchedUser?.name}</p>
                  <p>이메일: {emailMatchedUser?.email}</p>
                </Paper>
              </>
            )}
            <Box sx={{ mt: 2 }}>
              <TextField
                fullWidth
                label="ID"
                value={authId}
                onChange={(e) => setAuthId(e.target.value)}
                sx={{ mb: 2 }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleAuthSubmit();
                }}
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={authPassword}
                onChange={(e) => setAuthPassword(e.target.value)}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAuthSubmit} variant="contained">
              인증 후 연동하기
            </Button>
            <Button onClick={() => setShowAuthLinkModal(false)}>취소</Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}
